import store from '../store'
import moment from "moment";
import {currencyIdToLabel} from "@/config";
import {adminHKOrigin} from "@/config/constants";

const evaluateValueFilled = function (value, emptyStrAsFilled) {
    return typeof value !== 'undefined' && (emptyStrAsFilled || value !== '') && value !== null && !(Array.isArray(value) && value.length === 0);
};

const evaluateFieldValueFilled = function (value, field) {
    const {data_type} = field;
    return evaluateValueFilled(value, data_type === 'list')
}

const evaluateFieldValueFilledAndValid = function (value, field) {
    const {data_type, unit} = field;
    let checkAmountWithUnit = false;
    if ((data_type === 'decimal' || data_type === 'integer') && unit) {
        checkAmountWithUnit = true;
    }
    return evaluateFieldValueFilled(value, field) && !(checkAmountWithUnit && (value['amount'] === null || value[unit] === null));
}

const numberWithCommas = function (x) {
    const parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

const zFill = function (s, w) {
    s = String(s);
    while (s.length < w) {
        s = '0' + s;
    }
    return s;
}

const dateObjectToDateString = function (d) {
    return `${zFill(d.getFullYear(), 4)}-${zFill(d.getMonth() + 1, 2)}-${zFill(d.getDate(), 2)}`
}

const tempIdProvider = (function () {
    let counter = 0;
    return function (prefix) {
        if (typeof prefix === 'undefined') {
            prefix = ':';
        }
        return prefix + (++counter);
    }
})();

function deepCompare() {
    var i, l, leftChain, rightChain;

    function compare2Objects(x, y) {
        var p;

        // remember that NaN === NaN returns false
        // and isNaN(undefined) returns true
        if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
            return true;
        }

        // Compare primitives and functions.
        // Check if both arguments link to the same object.
        // Especially useful on the step where we compare prototypes
        if (x === y) {
            return true;
        }

        // Works in case when functions are created in constructor.
        // Comparing dates is a common scenario. Another built-ins?
        // We can even handle functions passed across iframes
        if ((typeof x === 'function' && typeof y === 'function') ||
                (x instanceof Date && y instanceof Date) ||
                (x instanceof RegExp && y instanceof RegExp) ||
                (x instanceof String && y instanceof String) ||
                (x instanceof Number && y instanceof Number)) {
            return x.toString() === y.toString();
        }

        // At last checking prototypes as good as we can
        if (!(x instanceof Object && y instanceof Object)) {
            return false;
        }

        if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
            return false;
        }

        if (x.constructor !== y.constructor) {
            return false;
        }

        if (x.prototype !== y.prototype) {
            return false;
        }

        // Check for infinitive linking loops
        if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
            return false;
        }

        // Quick checking of one object being a subset of another.
        // todo: cache the structure of arguments[0] for performance
        for (p in y) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            } else if (typeof y[p] !== typeof x[p]) {
                return false;
            }
        }

        for (p in x) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            } else if (typeof y[p] !== typeof x[p]) {
                return false;
            }

            switch (typeof (x[p])) {
                case 'object':
                case 'function':

                    leftChain.push(x);
                    rightChain.push(y);

                    if (!compare2Objects(x[p], y[p])) {
                        return false;
                    }

                    leftChain.pop();
                    rightChain.pop();
                    break;

                default:
                    if (x[p] !== y[p]) {
                        return false;
                    }
                    break;
            }
        }

        return true;
    }

    if (arguments.length < 1) {
        return true; //Die silently? Don't know how to handle such case, please help...
        // throw "Need two or more arguments to compare";
    }

    for (i = 1, l = arguments.length; i < l; i++) {

        leftChain = []; //Todo: this can be cached
        rightChain = [];

        if (!compare2Objects(arguments[0], arguments[i])) {
            return false;
        }
    }

    return true;
}

const authHelper = {
    isAppInitialized() {
        return store.state.isInitialized
    },
    isUserAuthenticated() {
        return store.state.userAuthenticated
    },
    getUserInfo() {
        return store.state.userInfo
    },
    setAppInitialized(b) {
        store.commit('setInitialized', b)
    },
    setInitialUserInfoLoading(b) {
        store.commit('setInitialUserInfoLoading', b)
    },
    setUserInfo(ui) {
        store.commit('setUserInfo', ui)
    },
    setUserAuthenticated(b) {
        store.commit('setUserAuthenticated', b)
    },
    setInitError(b) {
        store.commit('setInitError', b)
    },
    setUserOnceAuthenticated(b) {
        store.commit('setUserOnceAuthenticated', b)
    },
    isUserManager() {
        return store.state.isUserManager;
    },
    getCanAccessProjects() {
        return store.state.canAccessProjects;
    }
};

const workModeEdit = 'edit';
const workModeRead = 'read';

const durablePreferences = (function () {
    const localStorage = window.localStorage;
    const prefix = 'DA2PREF-';

    const keys = {
        homeViewMode: prefix + 'homeViewMode',
        workMode: prefix + 'workMode',
        lastSelectedViewer: prefix + 'lastSelectedViewer',
    };

    return {
        getHomeViewMode() {
            return localStorage.getItem(keys.homeViewMode);
        },
        setHomeViewMode(v) {
            localStorage.setItem(keys.homeViewMode, v);
        },
        getWorkMode() {
            return localStorage.getItem(keys.workMode);
        },
        setWorkMode(v) {
            return localStorage.setItem(keys.workMode, v);
        },
        getLastSelectedViewer() {
            return localStorage.getItem(keys.lastSelectedViewer);
        },
        setLastSelectedViewer(v) {
            return localStorage.setItem(keys.lastSelectedViewer, v);
        }
    }
})();

const userSettingsManager = (function () {
    const initialWorkMode = durablePreferences.getWorkMode() || workModeEdit;
    store.commit('setWorkMode', initialWorkMode);
    store.commit('setLastSelectedViewer', durablePreferences.getLastSelectedViewer());

    return {
        setWorkMode(v) {
            store.commit('setWorkMode', v);
            durablePreferences.setWorkMode(v);
        },
        getWorkMode() {
            return store.state.workMode;
        },
        setLastSelectedViewer(v) {
            store.commit('setLastSelectedViewer', v);
            durablePreferences.setLastSelectedViewer(v);
        },
        getLastSelectedViewer() {
            return store.state.lastSelectedViewer;
        }
    }
})();

const toTitleCase = function (str) {
    'use strict'
    var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i
    var alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/
    var wordSeparators = /([ :–—-])/

    return str.split(wordSeparators)
            .map(function (current, index, array) {
                if (
                        /* Check for small words */
                        current.search(smallWords) > -1 &&
                        /* Skip first and last word */
                        index !== 0 &&
                        index !== array.length - 1 &&
                        /* Ignore title end and subtitle start */
                        array[index - 3] !== ':' &&
                        array[index + 1] !== ':' &&
                        /* Ignore small words that start a hyphenated phrase */
                        (array[index + 1] !== '-' ||
                                (array[index - 1] === '-' && array[index + 1] === '-'))
                ) {
                    return current.toLowerCase()
                }

                /* Ignore intentional capitalization */
                if (current.substr(1).search(/[A-Z]|\../) > -1) {
                    return current
                }

                /* Ignore URLs */
                if (array[index + 1] === ':' && array[index + 2] !== '') {
                    return current
                }

                /* Capitalize the first letter */
                return current.replace(alphanumericPattern, function (match) {
                    return match.toUpperCase()
                })
            })
            .join('')
}

const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

const checkCrossPlatformEventCtrlKey = (event) => ((isMac && event.metaKey) || event.ctrlKey);

function createCopyHelper() {
    let obj;

    return {
        setCopyObj(value) {
            obj = value
        },
        getCopyObj() {
            return obj
        }
    }
}

const eventCopyHelper = createCopyHelper();

const formCopyHelper = createCopyHelper();

const entitiesCopyHelper = createCopyHelper();

const describeUsername = function (str, alter) {
    if (str) {
        if (str === authHelper.getUserInfo().username) {
            return 'me';
        }
        return str[0].toUpperCase() + str.substr(1);
    }
    return alter;
};

const describeUnixTs = function (ts, alter, fromNow) {
    if (typeof fromNow === 'undefined') {
        fromNow = false;
    }
    if (ts) {
        const dateObj = moment(ts, 'X');
        return fromNow ? dateObj.fromNow() : dateObj.format('MMM D, YYYY h:mm A');
    }
    return alter || '';
}

const exportDataToCSV = function (data, filename) {
    // Example data given in question text
    // var data = [
    //     ['name1', 'city1', 'some other info'],
    //     ['name2', 'city2', 'more info']
    // ];

// Building the CSV from the Data two-dimensional array
// Each column is separated by "," and new line "\n" for next row
    var processRow = function (row) {
        let finalVal = '';
        for (let j = 0; j < row.length; j++) {
            let innerValue = (row[j] === null || typeof row[j] === 'undefined') ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            }
            let result = innerValue.replace(/"/g, '""');
            if (result.search(/([",\n ])/g) >= 0)
                result = '"' + result + '"';
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };
    let csvContent = '';
    data.forEach(function (infoArray) {
        csvContent += processRow(infoArray);
    });

// The download function takes a CSV string, the filename and mimeType as parameters
// Scroll/look down at the bottom of this snippet to see how download is called
    let download = function (content, fileName, mimeType) {
        var a = document.createElement('a');
        mimeType = mimeType || 'application/octet-stream';

        if (navigator.msSaveBlob) { // IE10
            navigator.msSaveBlob(new Blob([content], {
                type: mimeType
            }), fileName);
        } else if (URL && 'download' in a) { //html5 A[download]
            a.href = URL.createObjectURL(new Blob([content], {
                type: mimeType
            }));
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
        }
    }

    download(csvContent, filename || 'dowload.csv', 'text/csv;encoding:utf-8');
}

const caseInsensitiveSortFn = function (a, b) {
    if (a.toLowerCase() < b.toLowerCase()) return -1;
    if (a.toLowerCase() > b.toLowerCase()) return 1;
    return 0;
};

const numberToKMB = function (labelValue) {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e+9

            ? Math.abs(Number(labelValue)) / 1.0e+9 + " billion"
            // Six Zeroes for Millions
            : Math.abs(Number(labelValue)) >= 1.0e+6

                    ? Math.abs(Number(labelValue)) / 1.0e+6 + " million"
                    // Three Zeroes for Thousands
                    : Math.abs(Number(labelValue)) >= 1.0e+3

                            ? Math.abs(Number(labelValue)) / 1.0e+3 + " thousand"

                            : Math.abs(Number(labelValue)) + "";
};

const buildORS = function (...ors) {
    if (ors.length < 2) {
        return ors.join('')
    }
    return 'ORS:' + ors.join(' OR ') + ':SRO';
};

const renderValueInCandidateItem = (value, field) => {
    try {
        if (value === null || typeof value === 'undefined') {
            return '';
        }

        if (field.data_type === 'list') {
            let found = field.all_option_values.filter(item => (item.option_value === value))[0];
            return found ? found.option_label : '<invalid value>';
        }

        if (field.data_type === 'multiple_list') {
            let options = field.all_option_values;
            let valueToLabel = {};
            options.forEach(item => {
                valueToLabel[item.option_value] = item.option_label;
            });
            return value.map(v => (valueToLabel[v])).join(', ');
        }

        if (field.data_type === 'date') {
            return dateObjectToDateString(new Date(value * 1000));
        }

        if (field.data_type === 'ratio') {
            const dataFormats = field['data_formats'];
            const leftControlLabel = dataFormats[0]['entry_label'];
            const leftProperty = dataFormats[0]['entry_name'];

            const rightControlLabel = dataFormats[1]['entry_label'];
            const rightProperty = dataFormats[1]['entry_name'];

            return `${leftControlLabel} ${value[leftProperty]} : ${value[rightProperty]} ${rightControlLabel}`;
        }

        if (field.data_type === 'range') {
            let fromValue;
            let toValue;
            let unit;
            let entryPrefix = '';
            let entrySuffix = '';
            let hasFromValue;
            let hasToValue;

            if ('unit' in field) {
                fromValue = value.amount.from;
                toValue = value.amount.to;
                unit = value[field.unit];
                if (field.unit === 'currency') {
                    entryPrefix = `${currencyIdToLabel[unit]} `;
                } else if (field.unit === 'percentage') {
                    entrySuffix = '%';
                }
            } else {
                fromValue = value.from;
                toValue = value.to;
            }

            hasFromValue = evaluateValueFilled(fromValue);
            hasToValue = evaluateValueFilled(toValue);

            if (field.range_entry_type === 'date') {
                if (hasFromValue) {
                    fromValue = dateObjectToDateString(new Date(fromValue * 1000));
                }
                if (hasToValue) {
                    toValue = dateObjectToDateString(new Date(toValue * 1000));
                }
            } else if (field.range_entry_type === 'decimal') {
                if (hasFromValue) {
                    fromValue = numberWithCommas(fromValue);
                }
                if (hasToValue) {
                    toValue = numberWithCommas(toValue);
                }
            }

            if (!hasFromValue) {
                fromValue = '?';
            } else {
                fromValue = entryPrefix + fromValue + entrySuffix;
            }

            if (!hasToValue) {
                toValue = '?';
            } else {
                toValue = entryPrefix + toValue + entrySuffix;
            }

            return `${fromValue} to ${toValue}`;
        }

        if (field.data_type === 'person_capacity') {
            const {gid, capacity_index_ids, person_bio_index_ids} = value;
            let paddings = [];
            if (capacity_index_ids && capacity_index_ids.length) {
                paddings.push(`Capacity: ${capacity_index_ids.join(', ')}`);
            }
            if (person_bio_index_ids && person_bio_index_ids.length) {
                paddings.push(`Bio: ${person_bio_index_ids.join(', ')}`)
            }
            return `"${gid}"` + (paddings.length ? ` (${paddings.join(' | ')})` : '');
        }

        if (field.data_type === 'single_gid') {
            return String(value);
        }

        if (field.data_type === 'entity' || field.data_type === 'multiple_list_v2') {
            return value.join(', ');
        }

        if (field.data_type === 'multi_object') {
            let result = `${value.length} item${value.length === 1 ? '' : 's'}`;
            if (value.length > 0) {
                result += ':';
            }
            value.forEach((obj, i) => {
                result += `\n${i + 1}. ` + field.object_items.map(object_field => {
                    return `${object_field.field_name}: ` + (renderValueInCandidateItem(obj[object_field.field_id], object_field) || '-')
                }).join(' / ')
            })
            return result;
        }

        if (value.constructor === Number) {
            return numberWithCommas(value);
        }

        if ('unit' in field) {
            const unit = value[field.unit];
            let amount = value['amount'];

            if (amount.constructor === Number) {
                amount = numberWithCommas(amount);
            }

            if (field.unit === 'currency') {
                return `${currencyIdToLabel[unit]} ${amount}`;
            } else if (field.unit === 'percentage') {
                return `${amount}%`;
            } else {
                return `${amount} ${unit}`;
            }
        }
        return value;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`error rendering candidate item for "${value}" in field "${field['field_id']}":`, e)
        return '<invalid value>'
    }
};

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

const placeholderDateMoment = moment('1111-11-11', 'YYYY-MM-DD', true);
const placeholderDateUnix = placeholderDateMoment.unix();

const transformArrayIntoString = (a) => {
    if (Array.isArray(a)) {
        return a.join(', ');
    }
    return a;
};

const getDataPointInSuggestionItem = (item, p, toString = true) => {
    let _source = item['_source'];
    let highlight = _source['highlight'] || {};
    _source = _source['_source'];
    if (toString) {
        return transformArrayIntoString(highlight[p]) || transformArrayIntoString(_source[p]) || null;
    }
    return highlight[p] || _source[p] || null;
};

const getReviewPersonLinkToAdminHK = (gid) => {
    return `${adminHKOrigin}/person/${gid}/review/`;
}

const getReviewCompanyLinkToAdminHK = (gid) => {
    return `${adminHKOrigin}/company/${gid}/review/`;
}

const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');

const getAppropriateNoun = (word, count) => {
    return word + (Math.abs(count) > 1 ? 's' : '');
}

/**
 * Validate fields
 * @param fields {Array<Object>}
 * @param eventId {String}
 * @param values {Object}
 * @param checkCompulsory {Boolean}
 * @param checkStrictValidation {Boolean}
 */
function validateFields(fields, eventId, values, checkCompulsory, checkStrictValidation) {
    const items = [];
    const ratingCompanies = [];

    fields.forEach((field, i) => {
        const v = values[field.field_id];

        if (((['decimal', 'integer', 'range'].indexOf(field.data_type) !== -1 && field.unit) || field.data_type === 'ratio') && typeof v === 'object' && v !== null) {
            for (let k in v) {
                if (v.hasOwnProperty(k) && v[k] === null) {
                    items.push({
                        fieldName: field.field_name,
                        explanation: 'the value is incomplete',
                        fieldIndex: i,
                        fieldId: field.field_id,
                        eventId,
                    });
                    return;
                }
            }
        }

        if (field.data_type === 'nested_list' && typeof v === 'object' && v !== null) {
            if (v.indexOf(null) >= 0) {
                items.push({
                    fieldName: field.field_name,
                    explanation: 'the value is incomplete',
                    fieldIndex: i,
                    fieldId: field.field_id,
                    eventId,
                });
            }
            const ratingCompany = v[0];
            if (ratingCompany !== null) {
                if (ratingCompanies.indexOf(ratingCompany) >= 0) {
                    items.push({
                        fieldName: field.field_name,
                        explanation: 'the Rating Company Name is not unique in this event',
                        fieldIndex: i,
                        fieldId: field.field_id,
                        eventId,
                    });
                } else {
                    ratingCompanies.push(ratingCompany);
                }
            }
        }

        if (checkCompulsory && field.is_compulsory && !evaluateFieldValueFilled(v, field) && !(typeof field.note !== 'undefined' && field.note !== null && evaluateValueFilled(values[field.note]))) {
            items.push({
                fieldName: field.field_name,
                explanation: 'must be filled',
                fieldIndex: i,
                fieldId: field.field_id,
                eventId,
            });
            return;
        }

        if (evaluateValueFilled(v) && checkStrictValidation) {
            let valueToValidate;
            let subItems = [];

            if (field.data_type === 'range') {
                const rangeEntryType = field['range_entry_type'];
                let fromValue;
                let toValue;
                if ('unit' in field) {
                    fromValue = v.amount.from;
                    toValue = v.amount.to;
                } else {
                    fromValue = v.from;
                    toValue = v.to;
                }
                if (rangeEntryType === 'decimal') {
                    if (evaluateValueFilled(fromValue) && evaluateValueFilled(toValue) && fromValue > toValue) {
                        subItems.push('the range is not reasonable')
                    }
                } else if (rangeEntryType === 'date') {
                    // check if both "from" and "to" is filled
                    if (!(evaluateValueFilled(fromValue) && evaluateValueFilled(toValue))) {
                        subItems.push('the range is incomplete');
                    } else {
                        // of course, either item can be "1111-11-11".
                        // if both are actually filled, "from" < "to".
                        // eslint-disable-next-line
                        if (placeholderDateUnix === fromValue) {
                            fromValue = null;
                        }
                        if (placeholderDateUnix === toValue) {
                            toValue = null;
                        }
                        if (evaluateValueFilled(fromValue) && evaluateValueFilled(toValue) && !(fromValue < toValue)) {
                            subItems.push('the range is not reasonable');
                        }
                    }
                }
            } else if (field.data_type === 'entity') {
                if (field.max_entity_num && v.length > field.max_entity_num) {
                    subItems.push(`only up to ${field.max_entity_num} item(s) allowed`)
                }
            }

            if (field.validation && field.validation.strict_validation) {
                switch (field.data_type) {
                    case 'decimal':
                    case 'integer':
                        if (v.constructor === Number) {
                            valueToValidate = v;
                        } else {
                            valueToValidate = v.amount;
                        }
                        for (let k in field.validation.strict_validation) {
                            if (field.validation.strict_validation.hasOwnProperty(k)) {
                                const target = field.validation.strict_validation[k];
                                switch (k) {
                                    case 'less_than':
                                        if (!(valueToValidate < target)) {
                                            subItems.push('the amount should be less than ' + target)
                                        }
                                        break
                                    case 'larger_than':
                                        if (!(valueToValidate > target)) {
                                            subItems.push('the amount should be larger than ' + target)
                                        }
                                        break
                                    case 'less_eq':
                                        if (!(valueToValidate <= target)) {
                                            subItems.push('the amount should be less than or equal to ' + target)
                                        }
                                        break
                                    case 'larger_eq':
                                        if (!(valueToValidate >= target)) {
                                            subItems.push('the amount should be larger than or equal to ' + target)
                                        }
                                        break
                                }
                            }
                        }
                        break;
                    case 'multiple_list':
                        if (!Array.isArray(v)) {
                            break;
                        }
                        for (let k in field.validation.strict_validation) {
                            if (field.validation.strict_validation.hasOwnProperty(k)) {
                                const target = field.validation.strict_validation[k];
                                switch (k) {
                                    case 'max_selections':
                                        if (v.length > target) {
                                            subItems.push('the selected items cannot exceed ' + target)
                                        }
                                        break;
                                }
                            }
                        }
                        break;
                }
            }

            if (subItems.length) {
                items.push({
                    fieldName: field.field_name,
                    explanation: subItems.join(' and '),
                    fieldIndex: i,
                    fieldId: field.field_id,
                    eventId,
                })
            }
        }
    });

    return items;
}

export {
    isMac,
    evaluateValueFilled,
    numberWithCommas,
    dateObjectToDateString,
    tempIdProvider,
    deepCompare,
    authHelper,
    checkCrossPlatformEventCtrlKey,
    toTitleCase,
    eventCopyHelper,
    describeUnixTs,
    describeUsername,
    durablePreferences,
    exportDataToCSV,
    caseInsensitiveSortFn,
    userSettingsManager,
    workModeRead,
    workModeEdit,
    numberToKMB,
    buildORS,
    renderValueInCandidateItem,
    escapeRegExp,
    placeholderDateUnix,
    transformArrayIntoString,
    getDataPointInSuggestionItem,
    getReviewPersonLinkToAdminHK,
    genRanHex,
    getAppropriateNoun,
    evaluateFieldValueFilled,
    evaluateFieldValueFilledAndValid,
    validateFields,
    entitiesCopyHelper,
    formCopyHelper,
    getReviewCompanyLinkToAdminHK
}
